import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu.jsx';

export function Layout({ children }) {
  return (
    <div>
      <NavMenu />
      <Container tag="main" className="pb-5">
        {children}
      </Container>
    </div>
  );
}
